export default "/_next/static/chunks/fonts/Lato-Regular-latin-e775ceff7a09df48e9e92ffc545a70cc.woff2";